import withAddToQuote from 'components/common/hoc/withAddToQuote/withAddToQuote'
import ApplySavingsButton from './ApplySavingsButton'

export default withAddToQuote(ApplySavingsButton)
